import { render, staticRenderFns } from "./StatePublicationError.vue?vue&type=template&id=029054bc&scoped=true&lang=html&"
import script from "./StatePublicationError.vue?vue&type=script&lang=js&"
export * from "./StatePublicationError.vue?vue&type=script&lang=js&"
import style0 from "./StatePublicationError.vue?vue&type=style&index=0&id=029054bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029054bc",
  null
  
)

component.options.__file = "StatePublicationError.vue"
export default component.exports